import { render, staticRenderFns } from "./AppItems.vue?vue&type=template&id=646d5d12&scoped=true"
import script from "./AppItems.vue?vue&type=script&lang=ts"
export * from "./AppItems.vue?vue&type=script&lang=ts"
import style0 from "./AppItems.vue?vue&type=style&index=0&id=646d5d12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646d5d12",
  null
  
)

export default component.exports